import type { IconSvgObject } from './types';

const PathfinderExcludeIcon: IconSvgObject = [
  ["path", { d: "M9 13V15L11.0003 14.9993M15 10.9993V9H13M9.06301 10.5C9.2439 9.7972 9.7972 9.2439 10.5 9.06301M13.5 14.9356C14.2024 14.7548 14.7554 14.2021 14.9366 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 6.5V4C15 2.89543 14.1046 2 13 2H4C2.89543 2 2 2.89543 2 4V13C2 14.1046 2.89543 15 4 15H6.5M9 17.5V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9H17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PathfinderExcludeIcon;
